var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container-form",attrs:{"fluid":""}},[_c('div',{staticClass:"field-set-form multiple-field-sets"},[(_vm.loaded)?_c('v-container',{staticClass:"field-set-form-inner-container",attrs:{"fluid":""}},[(_vm.item && _vm.item.id)?_c('CustomerComponent',{attrs:{"item":_vm.item,"edit":_vm.edit}}):_vm._e()],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }